import React from "react";
import "./preguntas.css";

function Preguntas({
  sectionOptions,
  selectedSection,
  onSelectSection,
  questionMode,
  onQuestionModeChange,
  questionText,
  onQuestionTextChange,
  contextType,
  onContextTypeChange,
  contextText,
  onContextTextChange,
  reference,
  onReferenceChange,
  imageHeader,
  onImageHeaderChange,
  imageUrl,
  onImageUrlChange,
  imageLibraryText,
  onImageLibraryChange,
  imageOptions,
  selectedImageUrl,
  onImageSelectionChange,
  contextOptions,
  selectedContextId,
  onContextSelectionChange,
  answerA,
  onAnswerAChange,
  answerB,
  onAnswerBChange,
  answerC,
  onAnswerCChange,
  answerD,
  onAnswerDChange,
  correctAnswer,
  onCorrectAnswerChange,
  url,
  onUrlChange,
  onSubmit,
  onCancelEdit,
  editingQuestionId,
  hasSections,
  loading,
  hasCuadernillo,
}) {
  const showQuestionUrl = questionMode !== "conjunto" || contextType !== "figura";
  const contextHelpText = questionMode === "conjunto"
    ? (contextType === "texto"
      ? "Selecciona un conjunto existente o deja la selección vacía para usar una pregunta independiente."
      : contextType === "figura"
        ? "Selecciona una figura existente o deja la selección vacía para usar una pregunta independiente."
        : "")
    : "Escribe una pregunta individual y sus respuestas.";
  const currentImageOptions = imageOptions && imageOptions.length > 0 ? imageOptions : (selectedImageUrl ? [selectedImageUrl] : []);
  const filteredContextOptions = contextOptions ? contextOptions.filter((option) => option.contextType === contextType) : [];

  return (
    <div className="icfes-card">
      <p className="icfes-card-title">Crear pregunta</p>
      <div className="icfes-form-group">
        <span>Seccion</span>
        <select
          value={selectedSection}
          onChange={(e) => onSelectSection(e.target.value)}
          disabled={!hasSections}
          className="icfes-input"
        >
          <option value="" disabled>
            {hasSections ? "Selecciona seccion" : "No hay secciones"}
          </option>
          {sectionOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div className="icfes-form-group">
        <span>Tipo de pregunta</span>
        <select
          value={questionMode}
          onChange={(e) => onQuestionModeChange(e.target.value)}
          className="icfes-input"
        >
          <option value="individual">Pregunta individual</option>
          <option value="conjunto">Conjunto de preguntas</option>
        </select>
      </div>

      {questionMode === "conjunto" && (
        <div className="icfes-form-group">
          <span>Tipo de contexto</span>
          <select
            value={contextType}
            onChange={(e) => onContextTypeChange(e.target.value)}
            className="icfes-input"
          >
            <option value="texto">Texto base</option>
            <option value="figura">Figura</option>
          </select>
        </div>
      )}

      {questionMode === "conjunto" && (
        <div className="icfes-form-group">
          <span>Seleccionar conjunto</span>
          <select
            aria-label="Seleccionar conjunto"
            value={selectedContextId || ""}
            onChange={(e) => onContextSelectionChange(e.target.value)}
            className="icfes-input"
          >
            <option value="">Sin conjunto</option>
            {filteredContextOptions.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      )}

      {questionMode === "conjunto" && contextType === "texto" && (
        <>
          <div className="icfes-form-group">
            <span>Texto base</span>
            <textarea
              placeholder="Escribe el texto que se debe leer antes de responder"
              value={contextText}
              onChange={(e) => onContextTextChange(e.target.value)}
              className="icfes-textarea"
            />
          </div>
          <div className="icfes-form-group">
            <span>Referencia</span>
            <textarea
              placeholder="Escribe la referencia o cita del texto"
              value={reference}
              onChange={(e) => onReferenceChange(e.target.value)}
              className="icfes-textarea"
            />
          </div>
        </>
      )}

      {contextType === "figura" && (
        <>
          <div className="icfes-form-group">
            <span>Encabezado de la imagen</span>
            <input
              type="text"
              placeholder="Escribe el encabezado de la figura"
              value={imageHeader}
              onChange={(e) => onImageHeaderChange(e.target.value)}
              className="icfes-input"
            />
          </div>
          <div className="icfes-form-group">
            <span>URLs de imágenes</span>
            <textarea
              placeholder="Pega una URL por línea"
              value={imageLibraryText}
              onChange={(e) => onImageLibraryChange(e.target.value)}
              className="icfes-textarea"
            />
          </div>
          <div className="icfes-form-group">
            <span>Seleccionar imagen</span>
            <select
              value={selectedImageUrl}
              onChange={(e) => onImageSelectionChange(e.target.value)}
              className="icfes-input"
            >
              <option value="">Selecciona una imagen</option>
              {currentImageOptions.map((urlOption) => (
                <option key={urlOption} value={urlOption}>
                  {urlOption}
                </option>
              ))}
            </select>
          </div>
          <div className="icfes-form-group">
            <span>Imagen seleccionada</span>
            <input
              type="url"
              placeholder="URL seleccionada"
              value={imageUrl}
              onChange={(e) => onImageUrlChange(e.target.value)}
              className="icfes-input"
            />
          </div>
        </>
      )}

      {contextHelpText && (
        <p className="icfes-context-help">{contextHelpText}</p>
      )}

      <textarea
        placeholder="Texto de la pregunta"
        value={questionText}
        onChange={(e) => onQuestionTextChange(e.target.value)}
        className="icfes-textarea"
      />

      <div className="icfes-options-grid">
        {[
          { key: "a", value: answerA, setter: onAnswerAChange },
          { key: "b", value: answerB, setter: onAnswerBChange },
          { key: "c", value: answerC, setter: onAnswerCChange },
          { key: "d", value: answerD, setter: onAnswerDChange },
        ].map(({ key, value, setter }) => (
          <label key={key} className="icfes-option-row">
            <input
              type="radio"
              name="correctAnswer"
              value={key}
              checked={correctAnswer === key}
              onChange={(e) => onCorrectAnswerChange(e.target.value)}
              className="icfes-radio"
            />
            <input
              type="text"
              placeholder={`Respuesta ${key.toUpperCase()}`}
              value={value}
              onChange={(e) => setter(e.target.value)}
              className="icfes-input"
            />
          </label>
        ))}
      </div>

      

      {showQuestionUrl && (
        <input
          type="url"
          placeholder="URL opcional para la pregunta"
          value={url}
          onChange={(e) => onUrlChange(e.target.value)}
          className="icfes-input"
        />
      )}

      <div className="icfes-actions-row">
        <button
          type="button"
          className="icfes-button"
          disabled={!hasSections || loading}
          onClick={onSubmit}
        >
          {loading ? "Guardando..." : editingQuestionId ? "Actualizar pregunta" : "Guardar pregunta"}
        </button>
        {editingQuestionId && (
          <button
            type="button"
            className="icfes-button-secondary"
            disabled={loading}
            onClick={onCancelEdit}
          >
            Cancelar edición
          </button>
        )}
      </div>

      {!hasCuadernillo && (
        <p className="icfes-warning">Primero crea un cuadernillo para asignar secciones y preguntas.</p>
      )}
      {hasCuadernillo && !hasSections && (
        <p className="icfes-warning">Crea una seccion primero para poder asignar preguntas.</p>
      )}
    </div>
  );
}

export default Preguntas;
